module.exports = __webpack_public_path__ + "img/feature-9-2.ad4355b6.png";